import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';

import isObject from 'lodash/isObject';
import PropTypes from 'prop-types';
import React from 'react';
import { WrappedInputNumber } from '../input';
import LabelWrapper from '../LabelWrapper.component';

export class InsuranceField extends React.Component {
	onInsuranceChange = ({ target: { value } }) => {
		const { onChange } = this.props;
		const insuredFor = isNumber(value) ? value : 0;

		if (isFunction(onChange)) {
			onChange(insuredFor);
		}
	};

	render() {
		const { value, insuranceOption, disabled } = this.props;

		return (
			<WrappedInputNumber
				className="common-ui-insurance-field"
				name="insureFor"
				value={value}
				showButtons
				mode="currency"
				min={0}
				max={
					isObject(insuranceOption)
						? insuranceOption.maxInsuranceValueLimit
						: null
				}
				currency="USD"
				onChange={this.onInsuranceChange}
				disabled={disabled}
				dataqa="insure-for"
			/>
		);
	}
}

InsuranceField.propTypes = {
	// Insurance value
	value: PropTypes.number,

	// Function that changes on insurance value change
	onChange: PropTypes.func.isRequired,

	// Value of insurance options based on selected service
	insuranceOption: PropTypes.object,
};

export const InsuranceFieldWithLabel = LabelWrapper(
	InsuranceField,
	'common-ui-insurance-field-wrapper'
);
